/** The token's shape, as a regex SOURCE fragment so every reader builds
 *  from one declaration. Invite tokens are 64 lowercase hex chars (32
 *  random bytes, hex-encoded by the DB — `class_enrollments.invite_token`).
 *
 *  Shared because the two readers fail in OPPOSITE directions if they drift.
 *  The guard below fails CLOSED (a longer token 404s, loud, caught in
 *  minutes); the analytics redactor that also matches this shape fails OPEN,
 *  quietly letting live claimable tokens through to a durable person
 *  profile. A shared source means the loud failure is the one that fires. */
export const INVITE_TOKEN_PATTERN = "[0-9a-f]{64}";

/** A cheap shape check before the claim RPC so a mangled or hand-typed
 *  `/join/<token>` URL renders "not found" without a round trip — the RPC
 *  remains the authority. */
export function isPlausibleInviteToken(v: string): boolean {
  return new RegExp(`^${INVITE_TOKEN_PATTERN}$`).test(v);
}
